"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userLanguages = exports.mobileDatePickerOptions = void 0;
const userLanguages = exports.userLanguages = {
  en: "en",
  es: "es",
  fr: "fr",
  pt: "pt",
  zh: "zh",
  tl: "tl",
  ja: "ja",
  hi: "hi",
  it: "it",
  de: "de",
  ko: "ko"
};
const mobileDatePickerOptions = exports.mobileDatePickerOptions = {
  [userLanguages.en]: {
    form_controls: {
      save: "Save",
      cancel: "Cancel"
    },
    date_controls: {
      check_in: "CHECK IN",
      check_out: "CHECK OUT",
      select_date: "Select Date"
    },
    nav_controls: {
      prev_month: "Go to previous month",
      next_month: "Go to next month"
    },
    select: "Select"
  },
  [userLanguages.es]: {
    form_controls: {
      save: "Salvar",
      cancel: "Cancelar"
    },
    date_controls: {
      check_in: "REGISTRARSE",
      check_out: "DESOCUPAR",
      select_date: "Seleccione Fecha"
    },
    nav_controls: {
      prev_month: "Ir al mes anterior",
      next_month: "Ir al próximo mes"
    },
    select: "Seleccionar"
  },
  [userLanguages.fr]: {
    form_controls: {
      save: "Sauvegarder",
      cancel: "Annuler"
    },
    date_controls: {
      check_in: "ENREGISTREMENT",
      check_out: "QUITTER",
      select_date: "Sélectionner une date"
    },
    nav_controls: {
      prev_month: "Aller au mois précédent",
      next_month: "Aller au mois suivant"
    },
    select: "Sélectionner"
  },
  [userLanguages.pt]: {
    form_controls: {
      save: "Salvar",
      cancel: "Cancelar"
    },
    date_controls: {
      check_in: "OCUPAR",
      check_out: "DESOCUPAR",
      select_date: "Selecione a data"
    },
    nav_controls: {
      prev_month: "Ir para o mês anterior",
      next_month: "Ir para o próximo mês"
    },
    select: "Selecione"
  },
  [userLanguages.zh]: {
    form_controls: {
      save: "保存",
      cancel: "取消"
    },
    date_controls: {
      check_in: "報到",
      check_out: "退房",
      select_date: "選擇日期"
    },
    nav_controls: {
      prev_month: "轉到上個月",
      next_month: "轉到下個月"
    },
    select: "選擇"
  },
  [userLanguages.tl]: {
    form_controls: {
      save: "I-save",
      cancel: "Kanselahin"
    },
    date_controls: {
      check_in: "MAG-CHECK IN",
      check_out: "MAG-CHECK OUT",
      select_date: "Pumili ng Petsa"
    },
    nav_controls: {
      prev_month: "Pumunta sa nakaraang buwan",
      next_month: "Pumunta sa susunod na buwan"
    },
    select: "Piliin"
  },
  [userLanguages.ja]: {
    form_controls: {
      save: "保存",
      cancel: "キャンセル"
    },
    date_controls: {
      check_in: "チェックイン",
      check_out: "チェックアウト",
      select_date: "日付を選択"
    },
    nav_controls: {
      prev_month: "前の月に移動",
      next_month: "次の月に移動"
    },
    select: "選択"
  },
  [userLanguages.hi]: {
    form_controls: {
      save: "सहेजें",
      cancel: "रद्द करें"
    },
    date_controls: {
      check_in: "चेक इन",
      check_out: "चेक आउट",
      select_date: "तिथि चुनें"
    },
    nav_controls: {
      prev_month: "पिछले महीने पर जाएं",
      next_month: "अगले महीने पर जाएं"
    },
    select: "चुनें"
  },
  [userLanguages.it]: {
    form_controls: {
      save: "Salva",
      cancel: "Annulla"
    },
    date_controls: {
      check_in: "CHECK-IN",
      check_out: "CHECK-OUT",
      select_date: "Seleziona data"
    },
    nav_controls: {
      prev_month: "Vai al mese precedente",
      next_month: "Vai al mese successivo"
    },
    select: "Seleziona"
  },
  [userLanguages.de]: {
    form_controls: {
      save: "Speichern",
      cancel: "Abbrechen"
    },
    date_controls: {
      check_in: "CHECK-IN",
      check_out: "CHECK-OUT",
      select_date: "Datum auswählen"
    },
    nav_controls: {
      prev_month: "Zum vorherigen Monat",
      next_month: "Zum nächsten Monat"
    },
    select: "Wählen"
  },
  [userLanguages.ko]: {
    form_controls: {
      save: "저장",
      cancel: "취소"
    },
    date_controls: {
      check_in: "체크인",
      check_out: "체크아웃",
      select_date: "날짜 선택"
    },
    nav_controls: {
      prev_month: "이전 달로 이동",
      next_month: "다음 달로 이동"
    },
    select: "선택"
  }
};